"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtNode = void 0;
const clock_1 = require("../../json-crdt-patch/clock");
class ExtNode {
    constructor(data) {
        this.data = data;
        this.api = undefined;
        /** @ignore */
        this.parent = undefined;
        this.id = data.id;
    }
    children(callback) { }
    child() {
        return this.data;
    }
    container() {
        return this.data.container();
    }
    /** @ignore */
    delta() { }
    // ---------------------------------------------------------------- Printable
    toString(tab, parentId) {
        return this.name() + (parentId ? ' ' + (0, clock_1.printTs)(parentId) : '') + ' ' + this.data.toString(tab);
    }
}
exports.ExtNode = ExtNode;
